<template>
  <div class="wrapper">
    <BusinessHeader v-if="this.isloginHendle"></BusinessHeader>
    <HeaderNav menuflg="2" v-else></HeaderNav>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
             _/                                                                                                                    _/
             _/      画面定義                                                                                                      _/
             _/                                                                                                                    _/
             _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link
                class="ico-home"
                :to="{
                  name: this.formInfo.isBop ? 'STFMFM02C29' : 'STFMFM01C01',
                }"
              >
                {{ this.formInfo.isBop ? "ファイル一覧" : "メインページ" }}
              </router-link>
            </li>
            <li v-if="!this.isloginHendle">
              <router-link :to="{ name: 'STFMFM02C01' }"
                >ファイル管理</router-link
              >
            </li>
            <li v-if="!this.isloginHendle">
              <router-link :to="{ name: 'STFMFM02C29' }"
                >ファイル一覧</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'STFMFM02C09' }"
                >ファイル詳細</router-link
              >
            </li>
            <li>
              <span class="current">ファイル・取引情報の改訂</span>
            </li>
          </ul>
        </div>
        <div class="content-header">
          <h1 class="h1">ファイル・取引情報の改訂</h1>
          <p class="sub-title">
            {{ this.formInfo.businessOperatorCode
            }}{{ this.formInfo.businessOperatorName }}
          </p>
        </div>
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning mt-10px" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
      </div>
      <div class="inner mt-6px padding-t-10px padding-b-5px">
        <div class="frm-row display-flex flex-column-left">
          <div class="ml-15px order-2" :class="isMobile?'order-3':'order-2'">
            <label class="frm-file-label ml-10 w-50px">
              <input
                id="selectOnfFile"
                class="frm-file-item display-none"
                type="file"
                @click="
                  (e) => {
                    e.target.value = '';
                  }
                "
                @change="selectedFile"
                ref="refSelectFileInput"
              />
              <button
                class="frm-btn strong ml-0"
                type="button"
                @click="handleSelectFileBtnClicked"
                :disabled="this.isSelectFileBtnDisabled()"
                ref="refSelectFileBtn"
              >
                ファイルの改訂
              </button>
            </label>
          </div>
          <div class="ml-0px order-1" >
            <span class="frm-label mt-6px">名称</span>
            <input
              type="text"
              class="frm-text frm-size-xl"
              :class="{ error: isFileNameError }"
              maxlength="255"
              v-on:focusin="fileNameInputFocusin"
              v-on:focusout="fileNameInputFocusout"
              v-model="this.fileNameInputValue"
              :disabled="isFileNameDisabled"
              ref="refFileNameTextArea"
            />
            <!-- </textarea> -->
          </div>
          <div class="detail-form-name-error order-2"  v-if="this.fileNameErrorMsg != '' && isMobile">
            {{ this.fileNameErrorMsg }}
          </div>
        </div>
        <div class="detail-form-name-error" v-if="this.fileNameErrorMsg != '' && !isMobile">
          {{ this.fileNameErrorMsg }}
        </div>
      </div>

      <div class="inner block padding-top-10px">
        <div class="property-wrap mt-0px">
          <div class="property-left" style="background-color: #e9edf7">
            <div class="frm-row preview-control" v-if="pdfUrl != ''">
              <label>
                <font
                  >※PDFに変換して表示しているため実際のイメージと異なる場合がございます。</font
                >
              </label>
            </div>
            <div id="container" class="preview-area mt-8px height-1020px">
              <pdf-viewer  v-if="isMobile"  :url="pdfUrl"/>
              <iframe
                v-if="!isMobile"
                id="iframeArea"
                width="100%"
                height="100%;"
                :src="pdfUrl"
                type="application/pdf"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                border="0"
                scrolling="no"
                tabindex="-1"
              >
              </iframe>
            </div>
          </div>
          <div class="property-right">
            <p><strong>取引情報</strong></p>
            <div class="para">
              <div class="frm-row ml-15px">
                <span class="frm-label w-100px">取引年月日</span>
                <!-- No7日付のカレンダー入力対応 start-->
                <DateCalandar
                  :wareki="{
                    issueDateNengo: issueDateWarekiNengoInputValue,
                    issueDateWarekiYear: issueDateWarekiYearInputValue,
                    issueDateWarekiMonth: issueDateWarekiMonthInputValue,
                    issueDateWarekiDay: issueDateWarekiDayInputValue,
                  }"
                  :errorInfo="{
                    isIssueDateError,
                    isNengoInputError,
                    isYearInputError,
                    isMonthInputError,
                    isDayInputError,
                  }"
                  @handleDateChange="handleDateChange"
                ></DateCalandar>
                <!-- <select 
                  class="frm-select frm-size-76px"
                  :class="{ error: isIssueDateError | isNengoInputError}"
                  v-on:focusin="NengoInputFocusin"
                  v-on:focusout="NengoInputFocusout"
                  v-model="this.issueDateWarekiNengoInputValue"
                >
                  <option 
                    v-for="item in this.nengoList" 
                          :key="item" 
                          :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
                <input 
                  class="frm-text frm-size-xs alignright"
                  :class="{ error: isIssueDateError | isYearInputError}"
                  type="url" 
                  title=" "
                  maxlength="2"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  v-on:focusout="yearInputFocusout"
                  v-model="this.issueDateWarekiYearInputValue"
                >
                <span class="frm-unit">年</span>
                <input 
                  class="frm-text frm-size-xs ml-5px alignright"
                  :class="{ error: isIssueDateError | isMonthInputError}"
                  title=" "
                  type="url"
                  maxlength="2"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  v-on:focusout="monthInputFocusout"
                  v-model="this.issueDateWarekiMonthInputValue"
                >
                <span class="frm-unit">月</span>
                <input 
                  class="frm-text frm-size-xs ml-5px alignright"
                  :class="{ error: isIssueDateError | isDayInputError}"
                  title=" "
                  type="url"
                  maxlength="2"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  v-on:focusout="dayInputFocusout"
                  v-model="this.issueDateWarekiDayInputValue"
                  ref="refDay"
                >
                <span class="frm-unit">日</span> -->
                <!-- No7日付のカレンダー入力対応 end-->
              </div>
              <div
                class="detail-form-item-error"
                v-if="issueDateErrorMsg != ''"
              >
                {{ this.issueDateErrorMsg }}
              </div>
              <div class="frm-row ml-15px">
                <span class="frm-label w-100px">取引先</span>
                <input
                  id="companyTextArea"
                  type="text"
                  class="frm-text w-283px textarea-horizontal-scroll"
                  :class="{ error: isCompanyError }"
                  maxlength="52"
                  v-on:focusin="companyInputFocusin"
                  v-on:focusout="companyInputFocusout"
                  v-model="this.companyInputValue"
                  ref="refCompanyTextArea"
                />
              </div>
              <div
                class="detail-form-item-error"
                v-if="this.companyErrorMsg != ''"
              >
                {{ this.companyErrorMsg }}
              </div>
              <div class="frm-row ml-15px">
                <span class="frm-label w-70px">取引金額</span>
                <span class="ml-40px">
                  <input
                    type="url"
                    title=" "
                    class="frm-text frm-size-160px alignright"
                    :class="{ error: isAmountError }"
                    v-on:focusin="amountInputFocusin"
                    v-on:focusout="amountInputFocusOut"
                    v-model="this.amountInputValue"
                    ref="refAmout"
                    @input="amountInputValue = amountInputValue.replace(/[^\d]/g,'')"
                    maxlength="15"
                  />
                </span>
                <span class="frm-unit">円</span>
              </div>
              <div
                class="detail-form-item-error"
                v-if="this.amountErrorMsg != ''"
              >
                {{ this.amountErrorMsg }}
              </div>
            </div>
            <div>
              <p><strong>改訂理由</strong></p>
              <div class="mb-10px"></div>
              <div>
                <!-- <span class="ml-8px mb-18px"> -->
                  <textarea
                    type="text"
                    class="frm-text h-180px w-390px ml-15px"
                    :class="{ error: isUpdateReasonError }"
                    maxlength="200"
                    v-on:focusin="updateReasonInputFocusin"
                    v-on:focusout="updateReasonInputFocusout"
                    v-model="this.updateReasonInputValue"
                  ></textarea>
                <!-- </span> -->
              </div>
              <div
                class="updateReason-error"
                v-if="this.updateReasonErrorMsg != ''"
              >
                {{ this.updateReasonErrorMsg }}
              </div>
            </div>
            <div class="frm-btn-row footer-btn">
              <div class="frm-item grow center">
                <button
                  class="frm-btn strong"
                  type="button"
                  ref="refUpdateBtn"
                  @click="handleUpdateBtnClicked"
                  :disabled="this.isUpdateBtnDisabled()"
                >
                  確定
                </button>
                <button
                  class="frm-btn"
                  type="button"
                  ref="refCancelUpdateBtn"
                  @click="handleCancelUpdateBtnClicked"
                  :disabled="this.isProcessing"
                >
                  キャンセル
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <!-- キャンセルボタン押下による確認画面 -->
    <STFMFM02C08ConfirmDialog
      :isShow="this.cancelConfirmDialogSetting.isShow"
      :message="this.cancelConfirmDialogSetting.message"
      :confirmText="this.cancelConfirmDialogSetting.confirmText"
      :cancelText="this.cancelConfirmDialogSetting.cancelText"
      :cancelText3="this.cancelConfirmDialogSetting.cancelText3"
      :title="this.cancelConfirmDialogSetting.title"
      @confirm="cancelConfirmDialogConfirm"
      @cancel="cancelConfirmDialogCancel"
    >
    </STFMFM02C08ConfirmDialog>
    <!-- 10回目の更新確認 -->
    <STFMFM02C08ConfirmDialog
      :isShow="this.maxVersionConfirmDialogSetting.isShow"
      :message="this.maxVersionConfirmDialogSetting.message"
      :confirmText="this.maxVersionConfirmDialogSetting.confirmText"
      :cancelText="this.maxVersionConfirmDialogSetting.cancelText"
      :cancelText3="this.maxVersionConfirmDialogSetting.cancelText3"
      :title="this.maxVersionConfirmDialogSetting.title"
      @confirm="ver10ConfirmDialogConfirm"
      @cancel="ver10ConfirmDialogCancel"
    >
    </STFMFM02C08ConfirmDialog>
    <!-- AIOCR読取確認画面 -->
    <ConfirmDialog
      :isShow="this.aiocrConfirmDialogSetting.isShow"
      :message="this.aiocrConfirmDialogSetting.message"
      @confirm="aiocrConfirmDialogConfirm"
      @cancel="aiocrConfirmDialogCancel"
    >
    </ConfirmDialog>
  </div>
</template>

<style scoped>
.padding-t-10px {
  padding-top: 10px;
}

.padding-b-5px {
  padding-bottom: 5px;
}
.mt-6px {
  margin-top: 6px;
}
.frm-size-160px {
  width: 160px;
}
.mt-5px {
  margin-top: 5px;
}
.ml-35px {
  margin-left: 35px;
}
.ml-260px {
  margin-left: 260px;
}
.height-1020px {
  height: 1020px;
}
.position-absolute {
  position: absolute;
}
.ml-265px {
  margin-left: 265px;
}
.border-left-lpx-solid {
  border-left: 1px solid #cccfd2;
}
.padding-left-8px {
  padding-left: 8px;
}
.padding-top-10px {
  padding-top: 10px;
}
.h-43px {
  height: 43px;
}
.display-flex {
  display: flex;
}
.display-none {
  display: none;
}
.order-2 {
  order: 2;
}
.order-1 {
  order: 1;
}
.order-3 {
  order: 3;
}
.textarea-horizontal-scroll {
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.detail-form-item-error {
  margin-left: 125px;
  height: 12px;
  color: red;
  margin-bottom: 20px;
}
.updateReason-error {
  margin-left: 15px;
  height: 12px;
  color: red;
}
.detail-form-name-error {
  margin-left: 37px;
  height: 12px;
  color: red;
}

.w-283px {
  width: 283px;
}
.ml-40px {
  margin-left: 40px;
}
.mb-10px {
  margin-bottom: 10px;
}
.ml-8px {
  margin-left: 8px;
}
.mb-18px {
  margin-bottom: 10px;
}
.h-180px {
  height: 180px;
}
.w-390px {
  width: 392px;
}

@media (max-width: 768px) {
  .content-body2 .inner {
    padding: 0 15px;
  }
  .order-1 {
    width: 100%;
  }
  .order-1 > .frm-label {
    margin-bottom: 10px;
  }
  .order-2 {
    margin-left: 0;
  }
  .property-wrap .property-right {
    margin-left: 0;
  }
  .frm-row .date-picker-wrap {
    margin-left: 0;
  }
  .frm-row .ml-40px {
    margin-left: 0;
  }
  .frm-text.h-180px.w-390px.ml-8px {
    width: 100%;
    margin-left: 0;
  }
  .frm-size-xl {
    width: 100%;
    margin-left: 0;
  }
  .detail-form-item-error{
    margin-left: 15px;
  }
  .frm-text.h-180px.w-390px{
    width:calc(100% - 20px);
  }
  .preview-area{
    width:calc(100vw - 50px);
    height: calc((100vw - 50px) * 1.48);
    position: relative;
  }
  .detail-form-name-error{
    margin-left: 0;
    height:unset;
  }
  .flex-column-left{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
<script>
import { mapMutations, mapActions } from "vuex";
import _ from "lodash";
import Common from "@/util/common.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import BusinessHeader from "@/components/BusinessHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { getPDFApi } from "@/api/filemanage_download";
import validation from "../../util/validation";
import STFMFM02C08ConfirmDialog from "../../components/STFMFM02C08ConfirmDialog.vue";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import DateCalandar from "@/components/DateCalandar.vue";
import { PAPERTYPE_LIST,CHECK_FILE_SUFFIX} from "@/util/data.js";
import moment from "moment";
import common from "../../util/common";
import PdfViewer from "@/components/PdfViewer.vue"

// No4スキャナ保存対応 API_STFMFM02C08_RequirementCheck
import {
  API_STFMFM02C08_FilePreviewDisplay,
  API_STFMFM02C08_UpdateTradingInfo,
  API_STFMFM02C08_TempFileToPDF,
  API_STFMFM02C08_UnlockFile,
} from "@/api/Modules/FM02/STFMFM02C08.js";

export default {
  name: "STFMFM02C08",
  components: {
    ErrorMessage,
    HeaderNav,
    BusinessHeader,
    ConfirmDialog,
    STFMFM02C08ConfirmDialog,
    DateCalandar,
    PdfViewer
  },
  data() {
    return {
      isMobile:common.isMobile(),
      /** ログインユーザ区分 */
      isloginHendle:
        this.$cookies.get("isloginHendle") == "true" ? true : false,
      /** 遷移先ページ */
      toPageId: "",
      /** 書類種別リスト */
      paperList: PAPERTYPE_LIST,
      /** 処理中フラグ */
      isProcessing: true,
      /** 年号リスト */
      nengoList: new Array("", "令和", "平成"),
      /** OCR対象書類種類リスト */
      ocrPaperTypeList: new Array(
        // "注文書", "領収書", "請求書"
        1,
        4,
        6
      ),
      /** 禁止拡張子 */
      extentionList: CHECK_FILE_SUFFIX,
      /** 登録可能最大バージョン */
      maxVersion: 10,
      /** PDFURL */
      pdfUrl: "",
      /** ファイル改定有無 */
      uploadFileFlg: false,
      /** キャンセルボタン押下による確認画面 */
      cancelConfirmDialogSetting: {},
      /** 10回目の更新確認 */
      maxVersionConfirmDialogSetting: {},
      /** 更新完了確認画面 */
      // updatedConfirmDialogSetting: {},
      /** AIOCR読取確認画面 */
      aiocrConfirmDialogSetting: {},
      /** エラー情報 */
      errors: [],
      /** 選択ファイル情報 */
      files: [],

      // 取引情報inputデータ保持用
      issueDateWarekiNengoInputValue: "",
      issueDateWarekiYearInputValue: "",
      issueDateWarekiMonthInputValue: "",
      issueDateWarekiDayInputValue: "",
      companyInputValue: "",
      amountInputValue: "",
      updateReasonInputValue: "",
      fileNameInputValue: "",
      abc: "",
      // 取引情報inputデータバックアップ用
      bkIssueDateWarekiNengoInputValue: "",
      bkIssueDateWarekiYearInputValue: "",
      bkIssueDateWarekiMonthInputValue: "",
      bkIssueDateWarekiDayInputValue: "",
      bkCompanyInputValue: "",
      bkAmountInputValue: "",
      bkUpdateReasonInputValue: "",
      bkFileNameInputValue: "",
      /** 金額入力中 */
      isAmountInputing: false,

      // 項目エラーフラグ
      isNengoInputError: false,
      isYearInputError: false,
      isMonthInputError: false,
      isDayInputError: false,
      isIssueDateError: false,
      isUpdateReasonError: false,
      isCompanyError: false,
      isFileNameError: false,
      isAmountError: false,
      // 項目エラーメッセージ
      companyErrorMsg: "",
      issueDateErrorMsg: "",
      amountErrorMsg: "",
      updateReasonErrorMsg: "",
      fileNameErrorMsg: "",
      /** 画面情報 */
      formInfo: {},
      // No4スキャナ保存対応
      // showCheckConfirmDialog:false,
      // checkConfirmDialogContent:"スキャナ保存の読取要件を満たしているか\nチェックしますか？",
      // showCheckSuccessedDialog:false,
      // checkSuccessedDialogContent:"スキャナ保存の読取要件を満たしています。"
    };
  },
  mounted() {
    // this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.isProcessing = true;
    this.processDialogue(true);

    API_STFMFM02C08_FilePreviewDisplay().then(async (response) => {
      this.isProcessing = false;
      this.processDialogue(false);
      //正常の場合
      if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
        this.formInfo = response;
        this.copyPreViewDispalyResponse(response);
        // this.errors = [];
        if (_.eq(response.result, "0001")) {
          var errPara = "";
          if (response.errorCD == "MTCL1105") {
            errPara = "表示";
          }

          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [errPara])
            )
          );
          this.pdfUrl = "";
        } else {
         
          if(this.isMobile){
            this.pdfUrl = response.fileData
          } else {
            const res = await getPDFApi(response);
            this.pdfUrl = res.objURL + "#view=Fit";
          }
        }
      } else {
        // エラー表示
        this.errors.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }


      this.$nextTick(function () {
        this.formToTop();
        this.initFocus();
      });
    });
  },
  watch: {},
  computed: {
    /**
     * ファイル名入力有効制御
     */
    isFileNameDisabled() {
      var brRet = this.isProcessing || !this.uploadFileFlg;
      return brRet;
    },
  },
  methods: {
    ...mapMutations("businessModule", ["uploadCmfDialogue", "processDialogue"]),
    ...mapActions("businessModule", ["showProcessDialogue"]),

    /**
     * 確定ボタン有効制御
     */
    isUpdateBtnDisabled() {
      return this.isSelectFileBtnDisabled();
    },
    /**
     * ファイル改定ボタン有効制御
     */
    isSelectFileBtnDisabled() {
      return (
        this.isProcessing ||
        !this.formInfo.fileKey ||
        this.formInfo.fileKey.fileId == 0
      );
    },
    /**
     * ファイル選択ボタン押下
     */
    handleSelectFileBtnClicked() {
      this.$refs.refSelectFileInput.click();
    },
    /**
     * 金額入力項目のフォーカスイン
     */
    amountInputFocusin() {
      this.isAmountInputing = true;
      this.amountInputValue = this.amountInputValue.replace(/,/g, "");
    },
    /**
     * 金額入力項目のフォーカスアウト
     */
    amountInputFocusOut() {
      this.isAmountInputing = false;
      if (this.amountInputValue !== "") {
        if (this.isInteger(this.amountInputValue)) {
          this.amountInputValue = Number(
            this.amountInputValue
          ).toLocaleString();
        }
      }
    },
    /**
     * 名称のフォーカスアウト
     */
    fileNameInputFocusout() {
      this.fileNameInputValue = this.fileNameInputValue.trimEnd();
    },
    /**
     * 年のフォーカスアウト
     */
    yearInputFocusout() {
      this.issueDateWarekiYearInputValue =
        this.issueDateWarekiYearInputValue.replace(/^0+/, "");
    },
    /**
     * 月のフォーカスアウト
     */
    monthInputFocusout() {
      this.issueDateWarekiMonthInputValue =
        this.issueDateWarekiMonthInputValue.replace(/^0+/, "");
    },
    /**
     * 日のフォーカスアウト
     */
    dayInputFocusout() {
      this.issueDateWarekiDayInputValue =
        this.issueDateWarekiDayInputValue.replace(/^0+/, "");
    },
    /**
     * 取引のフォーカスアウト
     */
    companyInputFocusout() {
      this.companyInputValue = this.companyInputValue.trimEnd();
    },
    /**
     * 更新理由のフォーカスアウト
     */
    updateReasonInputFocusout() {
      this.updateReasonInputValue = this.updateReasonInputValue.trimEnd();
    },
    /**
     * 各入力項目の個別チェック
     */
    checkItemInput() {
      // 名称
      this.checkFileNameInput();

      // 取引年月日チェック
      this.checkIssueDateInput();

      // 取引先チェック
      this.checkCompanyInput();

      // 金額チェック
      this.checkTradingAmountInput();

      // 改訂理由
      this.checkUpdateReasonInput();

      if (this.errors.length > 0) {
        return false;
      }
      return true;
    },
    /**
     * 入力値チェック
     */
    checkInputData() {
      // バージョン上限チェック
      if (this.formInfo.fileKey.version >= 10) {
        this.setErrMsg("MTFM1430", []);
        return false;
      }
      // 入力値変更有無チェック
      if (!this.checkInputValueChanged()) {
        this.setErrMsg("MTFM1090", ["取引情報"]);
        return false;
      }
      // 個別チェック
      if (!this.checkItemInput()) {
        return false;
      }

      // [取引年月日(年)]～[取引金額]セット入力チェック
      if (!this.checkTradingInfo()) {
        return false;
      }

      // 改訂回数上限になる時の必須チェック
      if (this.formInfo.fileKey.version == this.maxVersion - 1) {
        // 取引年月日必須チェック
        this.checkIssueDateInputted();
        // 取引先必須チェック
        this.checkCompanyInputted();
        // 取引金額必須チェック
        this.checkTradingAmountInputted();
      }

      if (this.errors.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * [取引年月日]～[取引金額]セット入力チェック
     */
    checkTradingInfo() {
      // 未入力カウンター
      var cnt = 0;

      var nengoVal = this.issueDateWarekiNengoInputValue;
      // 取引年月日の年号に令和で年月日が空白の場合、年号も空白扱い
      if (!this.tradingDateInputted()) {
        nengoVal = "";
      }
      if (this.isBlank(nengoVal)) {
        cnt++;
      }
      if (this.isBlank(this.issueDateWarekiYearInputValue)) {
        cnt++;
      }
      if (this.isBlank(this.issueDateWarekiMonthInputValue)) {
        cnt++;
      }
      if (this.isBlank(this.issueDateWarekiDayInputValue)) {
        cnt++;
      }
      if (this.isBlank(this.companyInputValue)) {
        cnt++;
      }
      if (this.isBlank(this.amountInputValue)) {
        cnt++;
      }
      // すべて空白またはすべて入力の場合OK
      if (cnt == 0 || cnt == 6) {
        return true;
      } else {
        this.setErrMsg("MTFM1130", []);
        return false;
      }
    },
    /**
     * 取引年月日年号必須入力チェック
     */
    checkIssueDateNengoInput() {
      if (this.isBlank(this.issueDateWarekiNengoInputValue)) {
        this.isNengoInputError = true;
        return false;
      }
      return true;
    },
    /**
     * 取引年月日年必須入力チェック
     */
    checkIssueDateYearInput() {
      if (this.isBlank(this.issueDateWarekiYearInputValue)) {
        this.isYearInputError = true;
        return false;
      }
      return true;
    },
    /**
     * 取引年月日月必須入力チェック
     */
    checkIssueDateMonthInput() {
      if (this.isBlank(this.issueDateWarekiMonthInputValue)) {
        this.isMonthInputError = true;
        return false;
      }
      return true;
    },
    /**
     * 取引年月日日必須入力チェック
     */
    checkIssueDateDayInput() {
      if (this.isBlank(this.issueDateWarekiDayInputValue)) {
        this.isDayInputError = true;
        return false;
      }
      return true;
    },
    /**
     * 取引年月日必須入力チェック
     */
    checkIssueDateInputted() {
      var bRet = this.checkIssueDateNengoInput();
      bRet = this.checkIssueDateYearInput() && bRet;
      bRet = this.checkIssueDateMonthInput() && bRet;
      bRet = this.checkIssueDateDayInput() && bRet;
      if (!bRet) {
        if (this.isNullOrEmpty(this.issueDateErrorMsg)) {
          this.issueDateErrorMsg = Common.getMessage("MTCL1001", [
            "取引年月日",
          ]);
        }
        this.setErrMsg("MTFM1250", []);
      }
    },
    /**
     * 取引先必須入力チェック
     */
    checkCompanyInputted() {
      // 必須入力
      if (
        this.companyInputValue === null ||
        !validation.isRequired(this.companyInputValue.trim())
      ) {
        this.isCompanyError = true;
        // エラー表示
        this.companyErrorMsg = Common.getMessage("MTCL1001", ["取引先"]);
        this.setErrMsg("MTFM1250", []);
        return false;
      }
    },
    /**
     * 金額チェック
     */
    checkTradingAmountInput() {
      if (this.isAmountError == true) {
        return true;
      }

      if (this.isNullOrEmpty(this.amountInputValue)) {
        return true;
      }

      var inputtedAmount = this.amountInputValue.trim().replace(/,/g, "");
      if (this.isNullOrEmpty(inputtedAmount)) {
        return true;
      }

      // 整数チェック
      if (!this.isInteger(inputtedAmount)) {
        this.isAmountError = true;
        // エラー表示
        this.amountErrorMsg = Common.getMessage("MTCL1006", ["取引金額"]);
        this.setErrMsg("MTCL1119", []);
        return false;
      }

      // 範囲チェック
      if (!this.isNullOrEmpty(inputtedAmount)) {
        if (
          !validation.checkBetween(
            Number(inputtedAmount),
            -99999999999999,
            999999999999999
          )
        ) {
          this.isAmountError = true;
          // エラー表示
          this.amountErrorMsg = Common.getMessage("MTFM1370", []);
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }

      return true;
    },
    /**
     * 金額必須入力チェック
     */
    checkTradingAmountInputted() {
      // 必須入力
      if (this.isBlank(this.amountInputValue)) {
        this.isAmountError = true;
        // エラー表示
        this.amountErrorMsg = Common.getMessage("MTCL1001", ["取引金額"]);
        this.setErrMsg("MTFM1250", []);
        return false;
      }

      return true;
    },
    /**
     * 改訂理由必須入力チェック
     */
    checkUpdateReasonInput() {
      // 必須入力
      if (
        this.updateReasonInputValue === null ||
        !validation.isRequired(this.updateReasonInputValue.trim())
      ) {
        this.isUpdateReasonError = true;
        // エラー表示
        this.updateReasonErrorMsg = Common.getMessage("MTCL1001", ["改訂理由"]);
        this.setErrMsg("MTCL1119", []);
        return false;
      }

      // 改訂理由入力禁止文字チェック
      if (
        !validation.checkNationalkinsokuchar(this.updateReasonInputValue) ||
        !validation.CheckFileNameInvalid(this.updateReasonInputValue)
      ) {
        this.isUpdateReasonError = true;
        // エラー表示
        this.updateReasonErrorMsg = Common.getMessage("MTCL1098", ["改訂理由"]);
        this.setErrMsg("MTCL1119", []);
        return false;
      }
      return true;
    },
    /**
     * ファイル名必須入力チェック
     */
    checkFileNameInput() {
      // 必須入力
      if (this.isBlank(this.fileNameInputValue)) {
        this.isFileNameError = true;
        // エラー表示
        this.fileNameErrorMsg = Common.getMessage("MTCL1001", ["名称"]);
        this.setErrMsg("MTCL1119", []);
        return false;
      }

      // ファイル名入力禁止文字チェック
      if (
        !validation.checkNationalkinsokuchar(this.fileNameInputValue) ||
        !validation.CheckFileNameInvalid(this.fileNameInputValue)
      ) {
        this.isFileNameError = true;
        // エラー表示
        this.fileNameErrorMsg = Common.getMessage("MTCL1098", ["名称"]);
        this.setErrMsg("MTCL1119", []);
        return false;
      }

      // 拡張子htm,htmlはエラー
      if (
        !this.checkFileExtendion(
          this.fileNameInputValue.trim(),
          this.extentionList
        )
      ) {
        this.isFileNameError = true;
        this.fileNameErrorMsg = Common.getMessage("MTCL1107", []);
        this.setErrMsg("MTCL1119", []);
        return false;
      }
      // [名称]について以下が該当する。
      // ・拡張子を含めた文字列、又は拡張子を除いた文字列が以下のいずれかに該当する。
      //       COM0、COM、COM2、COM3、COM4、COM5、COM6、COM7
      //       COM8、COM9、LPT0、LPT1、LPT2、LPT3、LPT4、LPT5、
      //       LPT6、LPT7、LPT8、LPT9、CON、PRN、AUX、NUL、CLOCK$
      // ・.で始まる
      if (!this.isBlank(this.fileNameInputValue)) {
        if (!validation.CheckFileName(this.fileNameInputValue.trim())) {
          this.isFileNameError = true;
          this.fileNameErrorMsg = Common.getMessage("MTFM1190", ["名称"]);
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    /**
     * 取引先入力禁止文字チェック
     */
    checkCompanyInput() {
      if (!this.isBlank(this.companyInputValue)) {
        if (
          !validation.checkNationalkinsokuchar(this.companyInputValue.trim()) ||
          !validation.CheckFileNameInvalid(this.companyInputValue.trim())
        ) {
          this.isCompanyError = true;
          // エラー表示
          this.companyErrorMsg = Common.getMessage("MTCL1098", ["取引先"]);
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    /**
     *  取引年月日の数値チェック
     */
    checkIssueDateIsNumeric() {
      var bRet = true;

      var yearVal = this.issueDateWarekiYearInputValue;
      var monthVal = this.issueDateWarekiMonthInputValue;
      var dayVal = this.issueDateWarekiDayInputValue;

      if (!this.isYearInputError) {
        // 数値チェック
        if (!this.isNullOrEmpty(yearVal) && !validation.isNumeric(yearVal)) {
          // エラー表示
          this.isYearInputError = true;
          this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
          this.setErrMsg("MTCL1119", []);
        }
      }
      if (!this.isMonthInputError) {
        if (!this.isNullOrEmpty(monthVal) && !validation.isNumeric(monthVal)) {
          // エラー表示
          this.isMonthInputError = true;
          this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
          this.setErrMsg("MTCL1119", []);
        }
      }
      if (!this.isDayInputError) {
        if (!this.isNullOrEmpty(dayVal) && !validation.isNumeric(dayVal)) {
          // エラー表示
          this.isDayInputError = true;
          this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
          this.setErrMsg("MTCL1119", []);
        }
      }
      // 年月日のいずれかが数値以外の場合
      if (
        this.isYearInputError ||
        this.isMonthInputError ||
        this.isDayInputError
      ) {
        bRet = false;
      }

      return bRet;
    },
    /**
     * 取引年月日チェック
     */
    checkIssueDateInput() {
      var yearVal = this.issueDateWarekiYearInputValue;
      var monthVal = this.issueDateWarekiMonthInputValue;
      var dayVal = this.issueDateWarekiDayInputValue;
      var nengoVal = this.issueDateWarekiNengoInputValue;
      // 取引年月日の年号に令和で年月日が空白の場合、年号も空白扱い
      if (!this.tradingDateInputted()) {
        nengoVal = "";
      }

      // 取引年月日の数値チェック
      if (!this.checkIssueDateIsNumeric()) {
        return;
      }

      if (
        this.isNengoInputError ||
        this.isYearInputError ||
        this.isMonthInputError ||
        this.isDayInputError
      ) {
        return;
      }
      // 日付の整合性チェック
      // 未入力と入力混在時エラー
      var cnt = 0;
      if (!this.isNullOrEmpty(nengoVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(yearVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(monthVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(dayVal)) {
        cnt++;
      }

      if (cnt > 0 && cnt < 4) {
        // エラー表示
        this.isIssueDateError = true;
        this.issueDateErrorMsg = Common.getMessage("MTCL1011", ["取引年月日"]);
        this.setErrMsg("MTCL1119", []);
        return;
      }

      // 日付が入力された場合
      if (!this.isNullOrEmpty(nengoVal)) {
        // 年月日の整合性チェック
        var wreki = "0";
        if (this.issueDateWarekiNengoInputValue === "平成") {
          wreki = "1";
        }
        var bRet = false;
        var msg = validation.checkFilterDate(
          "1",
          wreki,
          yearVal,
          monthVal,
          dayVal,
          "取引年月日"
        );
        if (this.isNullOrEmpty(msg)) {
          // 和暦有効判定
          bRet = this.warekiCheck(
            Number(wreki),
            Number(yearVal),
            Number(monthVal),
            Number(dayVal)
          );
        } else {
          bRet = false;
        }
        if (!bRet) {
          this.isIssueDateError = true;
          this.issueDateErrorMsg = Common.getMessage("MTCL1011", [
            "取引年月日",
          ]);
          this.setErrMsg("MTCL1119", []);
          return;
        }
      }
    },
    /**
     * 取引情報変更有無チェック
     */
    checkInputValueChanged() {
      var bRet = true;

      var nengoChanged = true;
      if (
        this.issueDateWarekiNengoInputValue ===
        this.bkIssueDateWarekiNengoInputValue
      ) {
        nengoChanged = false;
      }
      if (
        !this.tradingDateInputted() &&
        this.issueDateWarekiNengoInputValue === "令和"
      ) {
        nengoChanged = false;
      }

      var inputtedAmount = "";
      if (!this.isNullOrEmpty(this.amountInputValue)) {
        inputtedAmount = this.amountInputValue.replace(/,/g, "");
      }

      bRet = !(
        !this.uploadFileFlg &&
        !nengoChanged &&
        this.issueDateWarekiYearInputValue ===
          this.bkIssueDateWarekiYearInputValue &&
        this.issueDateWarekiMonthInputValue ===
          this.bkIssueDateWarekiMonthInputValue &&
        this.issueDateWarekiDayInputValue ===
          this.bkIssueDateWarekiDayInputValue &&
        this.companyInputValue === this.bkCompanyInputValue &&
        inputtedAmount === this.bkAmountInputValue
      );
      return bRet;
    },
    /**
     * 確定ボタン押下
     */
    handleUpdateBtnClicked() {
      // エラー情報の初期化
      this.resetErrorFlg();

      this.checkInputData();
      if (this.errors.length > 0) {
        this.formToTop();
        return;
      }

      // 改訂回数上限になる時の確認
      if (this.formInfo.fileKey.version == this.maxVersion - 1) {
        this.maxVersionConfirmDialogSetting = {
          isShow: true,
          message: common.getMessage("MTFM5020", []),
          confirmText: "はい",
          cancelText: "いいえ",
        };
      } else {
        this.updateTradingInfo();
      }
    },
    /**
     * 取引情報更新処理
     */
    updateTradingInfo() {
      this.processDialogue(true);
      //パラメータ設定
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      // 入力値を反映
      // 年号
      var nengo = this.issueDateWarekiNengoInputValue.trim();
      if (!this.tradingDateInputted()) {
        nengo = "";
      }
      var amuont = "";
      if (this.isNullOrEmpty(this.amountInputValue)) {
        amuont = "";
      } else {
        amuont = this.amountInputValue.replace(/,/g, "");
      }

      let param = {
        FileKey: this.formInfo.fileKey,
        FileName: this.fileNameInputValue,
        IssueDateWarekiNengo: nengo,
        IssueDateWarekiY: this.issueDateWarekiYearInputValue,
        IssueDateWarekiM: this.issueDateWarekiMonthInputValue,
        IssueDateWarekiD: this.issueDateWarekiDayInputValue,
        Company: this.companyInputValue,
        Amount: amuont,
        UpdateReason: this.updateReasonInputValue,
      };
      formData.append("param", JSON.stringify(param));

      if (this.files.length > 0) {
        formData.append("FileInfos", this.files[0], this.fileNameInputValue);
      }

      API_STFMFM02C08_UpdateTradingInfo(formData, config).then(
        async (response) => {
          if (response.result == "0000") {
            // 正常時
            this.toPageId = { name: "STFMFM02C09" };
            this.closeForm();
          } else {
            // エラー表示
            var errpara = [];
            if (
              response.errorParaList != null &&
              response.errorParaList.length > 0
            ) {
              errpara = response.errorParaList;
            }
            this.setErrMsg(response.errorCD, errpara);
            this.formToTop();
          }
          this.processDialogue(false);
        }
      );
    },

    /**
     * 画面キャンセル
     */
    handleCancelUpdateBtnClicked() {
      this.toPageId = { name: "STFMFM02C09" };

      this.cancelConfirmDialogSetting = {
        isShow: true,
        message: Common.getMessage("MTCL2001", []),
        confirmText: "はい",
        cancelText: "いいえ",
      };
    },
    /**
     * キャンセル確認画面でOKボタン押下
     */
    cancelConfirmDialogConfirm() {
      this.cancelConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      this.processDialogue(true);
      // アンロック
      API_STFMFM02C08_UnlockFile().then(async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000")) {
          // ファイル詳細画面に遷移
          this.closeForm();
        } else {
          // エラー表示
          this.setErrMsg(response.errorCD, []);
        }
        this.processDialogue(false);
      });
    },
    /**
     * キャンセル確認画面でキャンセルボタン押下
     */
    cancelConfirmDialogCancel() {
      this.cancelConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      this.toPageId = "";
    },
    /**
     * 10回目の更新確認でOKボタン押下
     */
    ver10ConfirmDialogConfirm() {
      // 確認画面を閉じる
      this.maxVersionConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      // 更新処理実行
      this.updateTradingInfo();
    },
    /**
     * 10回目の更新確認でキャンセルボタン押下
     */
    ver10ConfirmDialogCancel() {
      this.maxVersionConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
    },
    /**
     * AIOCR読取確認でOKボタン押下
     */
    aiocrConfirmDialogConfirm() {
      this.aiocrConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      // 一時ファイルをpost
      this.getTempPdf(true);
    },
    /**
     * AIOCR読取確認でいいえボタン押下
     */
    aiocrConfirmDialogCancel() {
      this.aiocrConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      // 一時ファイルをpost
      this.getTempPdf(false);
    },
    /**
     * 呼び出し元画面へ遷移
     */
    closeForm() {
      this.$redirect(this.toPageId);
    },
    /**
     * 呼び出し元画面へ遷移
     */
    checkInputFile(realFiles) {
      // 拡張子htm,htmlはエラー
      if (
        !this.checkFileExtendion(realFiles[0].name.trim(), this.extentionList)
      ) {
        this.setErrMsg("MTCL1107", []);
        return false;
      }

      // 0バイトファイルはエラー
      if (realFiles[0].size == 0) {
        this.setErrMsg("MTFM1260", []);
        return false;
      }

      // 115Mを超えるファイルはエラー
      if (this.checkFileSize(realFiles[0].size)) {
        this.setErrMsg("MTFM1510", []);
        return false;
      }

      // ファイル名に入力禁止文字が使用されている。
      // ※設計書『D - ED005_共通処理設計書.xlsx』参照。
      if (!validation.checkNationalkinsokuchar(realFiles[0].name)) {
        this.setErrMsg("MTCL1098", ["選択したファイルの名称"]);
        return false;
      }

      if (!validation.CheckFileName(realFiles[0].name)) {
        this.setErrMsg("MTFM1190", ["選択したファイルの名称"]);
        return;
      }
      return true;
    },

    /**
     *
     */
    /**
     * ファイルの選択
     * @param {ファイル情報} e
     */
    selectedFile(e) {
      this.resetErrorFlg();
      let files = e.target.files || e.dataTransfer.files;
      let fileItem = files[0]
      let currentDate = new Date()
      let milliseconds = currentDate.getMilliseconds();
      let timeStamp = moment(currentDate).format("YYYYMMDDHHmmss") + `${milliseconds}`; 
      if(this.isMobile){
        let arrTemp = fileItem.name.split(".");
        let extandName = arrTemp[arrTemp.length - 1].toLowerCase();
        let newFileName = timeStamp +"_"+ 1 + "." + extandName
        fileItem = new File([fileItem],newFileName)

      }
      const realFiles = Array.from([fileItem]);

      if (!this.checkInputFile(realFiles)) {
        this.formToTop();
        return;
      }
      this.files.splice(0);
      const uniqFiles = realFiles.filter((realFile) => {
        const existFileIndex = this.files.findIndex(
          (e) => realFile.name === e.name
        );
        if (existFileIndex >= 0) {
          this.files[existFileIndex] = realFile;
          return false;
        }
        return true;
      });
      if (uniqFiles.length) {
        this.files.push(...uniqFiles);
      }
      // No4スキャナ保存対応
      // this.showCheckConfirmDialog = true
      // this.checkConfirmDialogContent = 'スキャナ保存の読取要件を満たしているか\nチェックしますか？'

      // AIOCR契約で書類種類が"注文書"又は"領収書"又は"請求書"の場合
      if (
        this.formInfo.hasAIOCRLicense &&
        _.includes(this.ocrPaperTypeList, this.formInfo.paperType)
      ) {
        this.aiocrConfirmDialogSetting = {
          isShow: true,
          //message: AI-OCR({0})の読み取りを行いますか？
          message: common.getMessage("MTFM5100", [
            this.paperList[this.formInfo.paperType].name,
          ]),
          confirmText: "はい",
          cancelText: "いいえ",
        };
      }
      // 上記以外の場合
      else {
        this.getTempPdf(false);
      }
    },
    /**
     * 選択されたファイルのPDFイメージ取得
     * @param {*} aiocrFlg
     */
    getTempPdf(aiocrFlg) {
      this.isProcessing = true;
      this.processDialogue(true);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let formData = new FormData();
      formData.append("FileInfos", this.files[0], this.files[0].name);
      formData.append("PaperType", this.formInfo.paperType);
      formData.append("AiocrFlg", aiocrFlg);

      API_STFMFM02C08_TempFileToPDF(formData, config).then(async (response) => {
        if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
          this.uploadFileFlg = true;
          this.copyTradingInfo(response, aiocrFlg);

          // PDF変換失敗の場合
          if (_.eq(response.result, "0001")) {
            var errPara = "";
            if (response.errorCD == "MTCL1105") {
              errPara = "表示";
            }
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [errPara])
              )
            );
            this.pdfUrl = "";
          } else {
            // const objURL = encodeURI(response.fileData);
            // const file = `data:application/pdf;base64, ${objURL}`;
            // this.pdfUrl = file + "#view=fith&zoom=FitH";
            if(this.isMobile){
            this.pdfUrl = response.fileData
          } else {
            const res = await getPDFApi(response);
            this.pdfUrl = res.objURL + "#view=Fit";
          }

            if (!this.isNullOrEmpty(response.aiocrErrorCD)) {
              var msgParaList = [];
              if (
                response.aiocrErrorMSGParamList != null &&
                response.aiocrErrorMSGParamList.length > 0
              ) {
                msgParaList = response.aiocrErrorMSGParamList;
              }
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.aiocrErrorCD, msgParaList)
                )
              );
            }
          }
          this.$nextTick(function () {
            this.$refs.refFileNameTextArea.focus();
          });
        } else {
          this.pdfUrl = "";
          // エラー表示
          var errpara = [];
          if (
            response.errorParaList != null &&
            response.errorParaList.length > 0
          ) {
            errpara = response.errorParaList;
          }
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, errpara)
            )
          );
          this.$nextTick(function () {
            this.formToTop();
            this.initFocus();
          });
        }
        this.isProcessing = false;
        this.processDialogue(false);
        this.$nextTick(function () {
          this.formToTop();
        });
      });
    },

    /**
     * 初期フォーカス設定
     */
    initFocus() {
      this.$refs.refSelectFileBtn.focus();
    },
    /**
     * フラグの初期化
     */
    resetErrorFlg() {
      this.errors.splice(0);
      this.isNengoInputError = false;
      this.isIssueDateError = false;
      this.isYearInputError = false;
      this.isMonthInputError = false;
      this.isDayInputError = false;
      this.issueDateErrorMsg = "";
      this.isCompanyError = false;
      this.companyErrorMsg = "";
      this.isAmountError = false;
      this.amountErrorMsg = "";
      this.isUpdateReasonError = false;
      this.updateReasonErrorMsg = "";
      this.isFileNameError = false;
      this.fileNameErrorMsg = "";
    },
    /**
     * 画面表示時のresponseの値渡し
     * @param {レスポンス} response
     */
    copyPreViewDispalyResponse(response) {
      this.issueDateWarekiNengoInputValue = response.issueDateWarekiNengo;
      this.issueDateWarekiYearInputValue = response.issueDateWarekiY;
      this.issueDateWarekiMonthInputValue = response.issueDateWarekiM;
      this.issueDateWarekiDayInputValue = response.issueDateWarekiD;
      this.companyInputValue = response.company;
      this.amountInputValue = response.amount;
      if (!this.isNullOrEmpty(this.amountInputValue)) {
        this.amountInputValue = Number(this.amountInputValue).toLocaleString();
      }
      this.updateReasonInputValue = "";
      this.fileNameInputValue = response.fileKey.fileName;
      // バックアップ
      this.bkIssueDateWarekiNengoInputValue = response.issueDateWarekiNengo;
      this.bkIssueDateWarekiYearInputValue = response.issueDateWarekiY;
      this.bkIssueDateWarekiMonthInputValue = response.issueDateWarekiM;
      this.bkIssueDateWarekiDayInputValue = response.issueDateWarekiD;
      this.bkCompanyInputValue = response.company;
      this.bkAmountInputValue = response.amount;
      this.bkUpdateReasonInputValue = "";
      this.bkFileNameInputValue = this.fileNameInputValue;
      // 年号初期値
      if (this.isNullOrEmpty(this.issueDateWarekiNengoInputValue)) {
        this.issueDateWarekiNengoInputValue = "令和";
      }
      this.formInfo.businessOperatorName =
        "_" + this.formInfo.businessOperatorName;
    },

    /**
     * ファイル改定時のresponseの値渡し
     * @param {*} response
     * @param {*} aiocrFlg
     */
    copyTradingInfo(response, aiocrFlg) {
      this.fileNameInputValue = response.fileName;
      if (!this.isBlank(response.issueDateWarekiNengo)) {
        this.issueDateWarekiNengoInputValue = response.issueDateWarekiNengo;
        this.issueDateWarekiYearInputValue = response.issueDateWarekiY;
        this.issueDateWarekiMonthInputValue = response.issueDateWarekiM;
        this.issueDateWarekiDayInputValue = response.issueDateWarekiD;
      }
      if (!this.isBlank(response.company)) {
        this.companyInputValue = response.company;
      }
      if (!this.isBlank(response.amount)) {
        this.amountInputValue = Number(response.amount).toLocaleString();
      }
    },
    /**
     * null,empty判定
     * @param {判定対象} val
     */
    isNullOrEmpty(val) {
      if (val === null || val === "") {
        return true;
      } else {
        return false;
      }
    },
    /**
     * アップロードファイルの拡張子チェック
     * @param {ファイル名} fileName
     * @param {禁止された拡張子リスト} extentionList
     */
    checkFileExtendion(fileName, extentionList) {
      var bRet = true;
      if (this.isNullOrEmpty(fileName)) {
        return false;
      }

      var list = fileName.split(".");
      // 拡張子なしの場合
      if (list.length <= 1 || this.isNullOrEmpty(list[list.length - 1])) {
        return false;
      }
      // ファイル拡張子取得
      const extension = list[list.length - 1];
      // 許可しない拡張子の場合
      if (_.includes(extentionList, extension)) {
        return false;
      }
      return true;
    },
    /**
     * ファイルサイズ(115M)チェック
     * @param {ファイルサイズ} fileSize
     */
    checkFileSize(fileSize) {
      return fileSize / 1024 / 1024 / 115 > 1 ? true : false;
    },
    /**
     * エラー内容セット
     * @param {エラーコード} errCd
     * @param {エラーコードの埋め込み文字} param
     */
    setErrMsg(errCd, param) {
      // PDF変換エラーがある状態で別のエラーが来たら別のエラーを優先
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(errCd, Common.getMessage(errCd, param))
        );
      }
    },
    /**
     * 他の画面に遷移
     */
    moveToOtherForm(formId, param) {
      this.$router.push({
        name: formId,
        params: param,
      });
    },
    /**
     * 画面の最上位に移動
     */
    formToTop() {
      window.scroll({ top: 0, behavior: "smooth" });
    },
    /**
     * ```ts
     * 数値と"-"キーのみを受け付ける
     * "-"は以下の場合受け付けない
     *  1.入力後の文字列が整数ではない
     * ```
     * @param {キーイベント} e
     */
    amountOnKeyPress(e) {
      var selectStart = this.$refs.refAmout.selectionStart;
      var selectEnd = this.$refs.refAmout.selectionEnd;
      // 0～9又は"-"の場合
      if ((e.charCode >= 48 && e.charCode <= 57) || e.charCode == 45) {
        var amount = this.amountInputValue;
        // カーソルのstart,end位置で文字列を分割
        var val1 = amount.substring(0, selectStart);
        var val2 = amount.substring(selectStart, selectEnd);
        var val3 = amount.substring(selectEnd, amount.length);

        // カーソルのstart前の文字列+入力キーコード対応の文字列+カーソルのend後の文字列が"-"又は整数かの判定
        amount = val1 + String.fromCharCode(e.charCode) + val3;
        if (amount == "-" || this.isInteger(amount)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    /**
     * 和暦有効判定
     * @param {*} reki 和暦
     * @param {*} year 年
     * @param {*} month 月
     * @param {*} day 日
     * @returns チェック結果 true  : チェックOK / false : チェックNG
     */
    warekiCheck(reki, year, month, day) {
      if (isNaN(reki) || isNaN(year) || isNaN(month) || isNaN(day))
        return false;

      if (reki == 1) {
        //1:平成　1年1月8日～31年４月30日まで
        //平成元年チェック
        if (year == 1) {
          if (month == 1) {
            if (day < 8) return false;
          }
        }

        //令和元年以降チェック
        if (year == 31) {
          if (month >= 5) {
            if (day >= 1) return false;
          }
        }

        if (year > 31 || year < 1) {
          return false;
        }
      }
      if (reki == 0) {
        //0:令和　元年5月1日から
        //令和元年チェック
        if (year == 1 && month <= 4) {
          return false; // 令和
        }

        if (year < 1) {
          return false;
        }
      }
      return true;
    },
    /**
     * 整数チェック
     * @param {string} input
     */
    isInteger(input) {
      return String(input).match(/^-?[0-9]+$/) ? true : false;
    },

    /**
     * null、空白、スペース判定
     * @param {string} input
     */
    isBlank(input) {
      if (this.isNullOrEmpty(input)) {
        return true;
      }
      if (this.isNullOrEmpty(input.trim())) {
        return true;
      }
      return false;
    },
    /**
     * 取引年月日入力しているかを判定
     * 項目のすべてが空白又は年号のみ入力で且つ"令和"の場合未入力と判定
     */
    tradingDateInputted() {
      if (
        (this.isBlank(this.issueDateWarekiNengoInputValue) ||
          this.issueDateWarekiNengoInputValue == "令和") &&
        this.isBlank(this.issueDateWarekiYearInputValue) &&
        this.isBlank(this.issueDateWarekiMonthInputValue) &&
        this.isBlank(this.issueDateWarekiDayInputValue)
      ) {
        return false;
      } else {
        return true;
      }
    },
    // No7日付のカレンダー入力対応
    handleDateChange({
      issueDateNengo,
      issueDateWarekiYear,
      issueDateWarekiMonth,
      issueDateWarekiDay,
    }) {
      this.issueDateWarekiNengoInputValue = issueDateNengo.toString();
      this.issueDateWarekiYearInputValue = issueDateWarekiYear.toString();
      this.issueDateWarekiMonthInputValue = issueDateWarekiMonth.toString();
      this.issueDateWarekiDayInputValue = issueDateWarekiDay.toString();
    },
  },
  beforeRouteLeave(to, from, next) {
    // 画面遷移チェック
    if (
      !this.$cookies.get("SessionID") ||
      to.name == "STDSCM04C06" ||
      this.toPageId
    ) {
      next();
    } else {
      this.toPageId = to;
      this.cancelConfirmDialogSetting = {
        isShow: true,
        message: Common.getMessage("MTCL2001", []),
        confirmText: "はい",
        cancelText: "いいえ",
      };
    }
  },
};
</script>
